import React, { useState } from 'react'
import NumberFormat from 'react-number-format';
import MuiAlert from '@material-ui/lab/Alert';
import { Button, Dialog, DialogContent, DialogTitle, Divider, makeStyles, Snackbar } from '@material-ui/core';
import { InputFiled } from '../../molecules';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { addToReturSupplier, failedAddCartBarangRetur, FailedAddToReturSupplier } from '../../../config/redux/action';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
        thousandSeparator
        isNumericString
        prefix={'Rp '}
      />
    );
  }
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const AddReturToSupplier = ({HandleClickCloseReturDialog,...rest}) => {
    const useStyle = makeStyles((theme)=>({
        titleDialog:{
            width:'400px',
            [theme.breakpoints.down('sm')]:{
                width:'250px',
            },
            textAlign:'center',
        },
        button:{
            display:'flex',
            justifyContent:'space-between',
            paddingBottom:"5px",
        },
        textFiled:{
            width:'100%',
            paddingBottom:"7px",
        },
    }));
    const classes =useStyle();
    const dispatch = useDispatch();
    const {data}=useSelector(state=>state.loginReducers);
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const [openSnackbar,setOpenSnackbar] = useState(false);
    const handleCloseSnackBar = () => {
        setOpenSnackbar(false);
        setTimeout(()=>{
            dispatch(failedAddCartBarangRetur(''));
        },500)
    };
    const {FormRetur} = useSelector(state=>state.returReducers);
    const {idbarang,namabarang,sisastok,modal} = FormRetur;
    const {messageRetur,dataReturSupplier}=useSelector(state=>state.returSupplierReducers);
    const validationSchema = yup.object().shape({
        jumlah:yup.number().required('Jumlah tidak boleh kosong').positive('Jumlah tidak boleh bernilai negative').min(1,'Jumlah tidak boleh kurang dari 1').max(sisastok,'Jumlah barang tidak mencukupi'),
    })
    const formik = useFormik({
        enableReinitialize:true,
        initialValues:{
            idbarang:idbarang||0,
            namabarang:namabarang||0,
            modal:modal||0,
            jumlah:sisastok||0
        },
        validationSchema:validationSchema,
        onSubmit:(values)=>{
            const subtotal = parseInt(values.jumlah) * parseInt(modal);
            const existBarang = dataReturSupplier.filter(returSupplier =>returSupplier.idbarang === idbarang);
            if(existBarang.length > 0){
                dispatch(FailedAddToReturSupplier("Data barang ini sudah terdaftar dalam list retur ke supplier"));
                setOpenSnackbar(true);
            }else{
                const data={
                    'idbarang':idbarang,
                    'namabarang':namabarang,
                    'jumlah':values.jumlah,
                    'modal':modal,
                    'subtotal':subtotal,
                    'ref':"Stok Retur"
                }
                dispatch(addToReturSupplier(data,setOpenSnackbar));
                HandleClickCloseReturDialog();
                formik.handleReset();
            }
        }
    })
    return (
        <div>
            <Dialog open={false} {...rest}>
            <DialogTitle className={classes.titleDialog} id="retur-barang-dialog">Rincian Barang Retur</DialogTitle>
                <Divider/>
                <DialogContent>
                <InputFiled 
                id="idbarang" 
                name="idbarang" 
                label="ID barang" 
                disabled={true} 
                value={formik.values.idbarang}/>
                <InputFiled 
                id="namabarang" 
                name="namabarang" 
                label="Nama Barang"
                value={formik.values.namabarang}
                disabled={true}
                />
                <InputFiled 
                id="modal" 
                name="modal" 
                label="Modal"
                value={formik.values.modal}
                disabled={true}
                InputProps={{
                    style:{fontSize:20,fontWeight:'bold'},
                    inputComponent: NumberFormatCustom
                }}
                />
                <InputFiled 
                id="jumlah" 
                name="jumlah" 
                label="Jumlah"
                value={formik.values.jumlah}
                error={formik.touched.jumlah && Boolean(formik.errors.jumlah)}
                helperText={formik.touched.jumlah && formik.errors.jumlah}
                onChange={formik.handleChange}
                />
                <div className={classes.button}>
                <Button variant="contained" color="primary" onClick={formik.handleSubmit} 
                >Tambah</Button>
                <Button variant="contained" color="secondary" onClick={HandleClickCloseReturDialog} 
                >Keluar</Button>
                </div>
                </DialogContent>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={messageRetur==='Berhasil menambahkan barang ke daftar retur'?"success":"error"}>
                    {messageRetur}
                    </Alert>
            </Snackbar>
        </div>
    )
}

export default AddReturToSupplier
